import ActionsForm from '@/shared/mixins/actionsForm'
import ClientDetails from '../clientDetails/clientDetails.vue'
import PanelRequest from '../panelRequest/panelRequest.vue'
import PaymentConditionsDetails from '../paymentConditionsDetails/paymentConditionsDetails.vue'
import AttachmentsDetails from '../attachmentsDetails/attachmentsDetails.vue'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
// import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  components: { ClientDetails, PanelRequest, PaymentConditionsDetails, AttachmentsDetails },
  name: 'RequestDetails',
  mixins: [ActionsForm],
  props: ['dataDetails'],
  data () {
    return {
      pendencia: '',
      requestsRepproved: []
    }
  },
  mounted () {
    this.GetSolicitacoesReprovadas()
  },
  methods: {
    cancelarSolicitacao () {
      this.$refs['cancelarSolicitacaoModal'].show()
    },
    closeModalCancelar () {
      this.$refs['cancelarSolicitacaoModal'].hide()
    },
    repproveRequest (id, pendencia) {
      let data = {
        pendencia: pendencia
      }
      loading.push()
      RequestsRepository.ReprovarSolicitacao(id, data)
        .then(res => {
          this.dataDetails.status = 1
          loading.pop()
          toast.success('Reprovado com sucesso!')
          this.closeModalCancelar()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Erro ao Reprovar')
        })
    },
    GetSolicitacoesReprovadas () {
      loading.push()
      RequestsRepository.GetSolicitacoesReprovadas(this.dataDetails.id)
        .then(res => {
          this.requestsRepproved = res.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/requestDetails/requestDetails.js